<script lang="ts" setup>

</script>

<template>
  <div class="flex h-dvh w-dvw flex-col">
    <div
      class="
          relative
          flex
          h-14
          shrink-0
          grow-0
          items-center
          border-b
          border-b-gray-200
          px-2
          shadow-sm
          "
    >
      <slot name="header" />
    </div>
    <div class="grow overflow-y-auto">
      <slot />
    </div>
  </div>
</template>
